/**
 * Spis treści artykułu (blok _blog-post-toc).
 * Lista linków jest wyrenderowana w Liquid; ten skrypt jedynie nadaje
 * nagłówkom treści `id` zgodne z linkami — dopasowanie po kolejności,
 * z pominięciem pustych nagłówków (tak samo pomija je Liquid).
 */
class BlogPostToc extends HTMLElement {
  connectedCallback() {
    const levels = this.dataset.levels || 'h2';
    const scope =
      this.closest('.blog-post-naoko') || this.closest('.shopify-section') || document;

    const headings = Array.from(scope.querySelectorAll(levels)).filter(
      (heading) => heading.textContent.trim() !== '' && !this.contains(heading)
    );
    const links = Array.from(this.querySelectorAll('[data-toc-anchor]'));

    links.forEach((link, index) => {
      const heading = headings[index];
      if (heading) {
        heading.id = link.dataset.tocAnchor;
      } else {
        // Brak odpowiadającego nagłówka (np. treść zmieniona w edytorze) —
        // usuwamy martwy link zamiast zostawiać kotwicę donikąd.
        const item = link.closest('li');
        if (item) item.remove();
      }
    });
  }
}

if (!customElements.get('blog-post-toc')) {
  customElements.define('blog-post-toc', BlogPostToc);
}
